import { type Verktoy, BehandlerInnsynType, VerktoyKategori } from '../types/minhelseentities';
import type { HNVerktoyFrontend } from '../types/Resources';

const getBehandlerInnsynTypeTekst = (resources?: HNVerktoyFrontend, type?: BehandlerInnsynType): string | null | undefined => {
  if (type === BehandlerInnsynType.Krever) {
    return resources?.behandlerInnsynAlltid;
  } else if (type === BehandlerInnsynType.TilbysIVerktoy) {
    return resources?.behandlerInnsynVelges;
  }
  return null;
};

const getKategoriTekst = (resources?: HNVerktoyFrontend, kategori?: VerktoyKategori): string | null | undefined => {
  if (kategori === VerktoyKategori.SentralBrukerprofil) {
    return resources?.verktoyKategoriSentralProfil;
  }
  if (kategori === VerktoyKategori.SentralPseudonymisertBrukerprofil) {
    return resources?.verktoyKategoriSentralPseudonymisertProfil;
  }
  return null;
};

export const getVerktoyPersonvernTekst = (resources?: HNVerktoyFrontend, verktoy?: Verktoy): string => {
  const internEllerEksternSection = verktoy?.InterntVerktoy ? resources?.internVerktoyVillkar : resources?.eksterntVerktoyVillkar;
  const behandlerInnsynSection = getBehandlerInnsynTypeTekst(resources, verktoy?.Laeringsressurs.BehandlerInnsynType);
  const kategoriSection = getKategoriTekst(resources, verktoy?.VerktoyKategori);
  return [internEllerEksternSection, kategoriSection, behandlerInnsynSection].filter(Boolean).join('\n\n');
};
